import type { EntityAction } from "@firecms/core";
import { BusinessIcon, LinkIcon } from "@firecms/ui";
import type { Account } from "../collections/accounts";
import {
  buildAccountAdminUrl,
  copyTextToClipboard,
} from "../workspace/adminLinks";
import { buildAccountPath } from "../workspace/workspaceRoutes";
import { tableOnlyEntityAction } from "./entityActionDefaults";

export function buildManageAccountEntityAction(): EntityAction<Account> {
  return {
    key: "manage-account",
    name: "Manage account",
    icon: <BusinessIcon />,
    ...tableOnlyEntityAction,
    collapsed: false,
    onClick: ({ entity }) => {
      if (!entity) {
        return;
      }
      window.open(buildAccountPath(entity.id), "_blank", "noopener,noreferrer");
    },
  };
}

export function buildShareAccountAdminLinkEntityAction(): EntityAction<Account> {
  return {
    key: "share-account-link",
    name: "Share link",
    icon: <LinkIcon />,
    ...tableOnlyEntityAction,
    onClick: async ({ entity, context }) => {
      if (!entity) {
        return;
      }
      const ok = await copyTextToClipboard(buildAccountAdminUrl(entity.id));
      context.snackbarController.open({
        type: ok ? "success" : "error",
        message: ok ? "Link copied to clipboard" : "Could not copy link",
      });
    },
  };
}

export function buildAccountEntityActions(): EntityAction<Account>[] {
  return [
    buildManageAccountEntityAction(),
    buildShareAccountAdminLinkEntityAction(),
  ];
}
